// extracted by mini-css-extract-plugin
module.exports = {"container":"Greetings_container__3r_sM","iconStyle":"Greetings_iconStyle__18MkS"};